import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { getActiveBundleListAsync } from "../actions/activeBundleAction";

interface ActiveBundleItem {
  [key: string]: any;
}

interface PaginationState {
  pageNumber: number;
  count: number;
}

interface ActiveBundleState {
  loading: boolean;
  bundleList: ActiveBundleItem[];
  pagination: PaginationState;
}

const initialState: ActiveBundleState = {
  loading: false,
  bundleList: [],
  pagination: {
    pageNumber: 1,
    count: 0,
  },
};

const activeBundleSlice = createSlice({
  name: "activeBundleSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // 🔵 Pending
    builder.addMatcher(
      isAnyOf(getActiveBundleListAsync.pending),
      (state) => {
        state.loading = true;
      }
    );

    // 🔴 Rejected
    builder.addMatcher(
      isAnyOf(getActiveBundleListAsync.rejected),
      (state) => {
        state.loading = false;
      }
    );

    // 🟢 Fulfilled
    builder.addMatcher(
      isAnyOf(getActiveBundleListAsync.fulfilled),
      (state, action) => {
        state.loading = false;

        const res = action.payload;

        // Match expected backend structure
        state.bundleList = res?.data?.data ?? [];
        state.pagination.count = res?.data?.total ?? 0;

        state.pagination.pageNumber = action.meta.arg.paramData.page ?? 1;
      }
    );
  },
});

export default activeBundleSlice.reducer;
